import { render } from "./InstallVideos.vue?vue&type=template&id=447f1cdb"
import script from "./InstallVideos.vue?vue&type=script&lang=js"
export * from "./InstallVideos.vue?vue&type=script&lang=js"
script.render = render

export default script